// import React, { useState, useEffect } from "react";192.168.100
import './privacy.css';

function Index (){
    return (
    <>

    <div className="container">

        <header>
        <h1>Privacy Policy</h1>
        </header>  

        <div>
            <span>Effective Date: January 27, 2023</span>
            <span>Effective Date: September 7, 2023</span>
            <div>Welcome to Rava, and thanks for taking the time to read our Privacy Policy</div>
        </div>


        <h2>Information We Collect</h2>
        <p>“Personal Information” is information that identifies you as an individual or relates to an identifiable
individual. Our Services may ask to collect Personal Information, including:</p>

        <ul>
            <li>Name;</li>
            <li>Email Address;</li>
            <li>Payment Information;</li>
            <li>Telephone Number</li>
            <li>Gender;</li>
            <li>Height and Weight</li>
            <li>Certain information from your device, including photos; and </li>
            <li>Communications from users.</li>
        </ul>

        <div>
        If you disclose any Personal Information relating to other people to us or to our service providers in
        connection with the Services, you represent that you have the authority to do so and to permit us to
        use the information in accordance with this Privacy Policy.
        </div>

        <h3>How We Collect Personal Information</h3>
        <p>We and our service providers collect Personal Information in a variety of ways, including:</p>
        
        <div>
            <p>
                <strong>Registration and Profile Information:</strong>
                Information. You must create an account in order to use our Services. You
                can create an account by providing your name and email address.<br />
                You may also create an account by providing credentials to a social media account profile. We do not
                collect or store any of your social media profile information.<br />
                You may also voluntarily provide or edit your profile information within the App, or Services such as
                phone number, mailing address, gender, height, and weight, and information related to your health
                and condition diagnosis to help us tailor and personalize our services to you.
            </p>

            <p>
                <strong>Mobile Application:</strong>
                Application: This App may access or collect Personal Information in a variety of ways. We
                collect information you submit through the mobile application. We may also collect information you
                authorize the app to collect.
            </p>
            <p>
                <strong>Payment Information:</strong>
                Certain purchases through our Services may require that you provide financial
                account information, such as your credit card number, to our third-party service providers. Purchases
                for virtual goods are handled by third party app stores. We are not responsible for their policies and
                practices.
            </p>
            <p>
                <strong>Information Stored on Your Mobile Device: </strong>
                 With your permission, we may collect information
                stored on your mobile device, such as photos you post to the Service, or access resources on your
                mobile device, such as the camera when you decide to take a photo and post it to the Service.
            </p>
            <p>
                <strong>Communications: </strong>
                 We will collect information you provide when you communicate with us, such as
                any communications you send to customer support. We will also collect information that you may
                submit as part of participation in a promotional event.
            </p>
            <p>
                <strong>Persistent Log-In</strong>
                 If you choose to use a persistent log-in, for example, having your user name or
                password be remembered, others may be able to access information through your mobile device. If
                you are concerned about the unauthorized use or disclosure of information via your mobile device,
                you should lock your mobile device when not in use or log out of the persistent log-in feature.
            </p>
        </div>
        

        <h2>How We Collect Other Information</h2>
        <p>We also collect Other Information in a variety of ways, including:</p>

        <p>
            <strong>Mobile Application:</strong>
            Application: We may access or collect Other Information through the operating system of
            your mobile device or through information you submit through the mobile application.
        </p>
        <p>
            <strong>Cookies and Usage Data:</strong>
             We collect industry standard data from everyone who visits our Services.
            We may use common technologies, such as cookies, “clear gifs” and “web beacons,” to automatically
            collect information such as your IP address or other device address or ID, web browser and/or device
            type, the web pages or sites that you visit just before or just after you use our Service, the pages or
            other content you view or otherwise interact with on our Service, and the dates and times that you
            visit, access, or use our Services. We also may use these technologies to collect information regarding
            your interaction with email messages, such as whether you opened, clicked on, or forwarded a
            message. This information is gathered from all users and may be connected with other information
            we collect from you and are used to improve our communications or Services to you.
        </p>
        <p>
            <strong>Analytics</strong>
            We use Google Analytics, which uses cookies and similar technologies to collect and
            analyze information about use of the Services and report on activities and trends. This service may
            also collect information regarding the use of other websites, apps and online resources.
        </p>
        <p>
            <strong>Location Information</strong>
            We offer features that may require specific location data. If you choose to use
            these features, we may collect data about your physical location from your mobile device if your
            Operating System settings are enabled to send it to us. We cannot access this information without
            your explicit approval to share this data with us. We stop collecting this type of data when you stop
            using the feature.
        </p>

    <h2>How We Use Your Information</h2>

    <p>
        <strong>To Provide the Service</strong>
         We use your Personal Information to provide the Services’ functionality to
        you, including arranging access to your account and providing customer service.<br/>
        We will engage in these activities to manage our contractual relationship with you, and/or to comply
        with a legal obligation.
    </p>

    <p>
        <strong>Communications</strong>
         Your Personal Information is used to communicate with you, including by sending
        email messages, push notifications, or text messages. We may send administrative messages related
        to account management, customer service, system maintenance, or other related concerns. We will
        engage in these activities to manage our contractual relationship with you and/or to comply with a
        legal obligation. We may also use your Personal Information to send or to inform you about const features or products that we think you would be interested in. We will engage in this activity with
        your consent or where we have a legitimate business interest  
    </p>
    <p>
        <strong>Aggregate Data</strong>
        We may anonymize and aggregate Personal Information collected through our
        Services so that it will no longer be considered Personal Information. We do so to generate other
        data for our use, which we may use for any purpose, as it no longer identifies you or any other
        individual.
    </p>
    <p>
        <strong>To Accomplish Our Business Purpose</strong>
         We may use Personal Data in data analysis, for example, to
        improve the efficiency of our Services. We may also use such information for other purposes,
        including but not limited to, fraud and security monitoring purposes, to conduct audits to address
        legal, regulatory or contractual requirements, to maintain and improve our current Services, or to
        identify usage trends to determine which aspects of our Services are most valuable to users. We
        engage in these activities to manage our contractual relationship with you, to comply with a legal
        obligation, and/or based on our legitimate interest.
    </p>
    <p>
        <strong>With Your Consent</strong>
        We will use your information for any other purpose for which the information
        was provided by you or for which you provide consent.
    </p>

    <h2>How We Share Your Information</h2>

    <p>
        <strong>Vendors and Service Providers:</strong>
        We may share information we receive with vendors and service
providers we use only in connection with providing you our Services. Such providers may include,
among others, data analytics, web hosting, and payment processing.
    </p>

    <p>
        <strong>As Required By Law and Similar Disclosures:</strong>
         We may access, preserve, and disclose information if
we believe doing so is required or appropriate to: comply with applicable law and regulations;
cooperate with law enforcement requests and legal process, such as a court order or subpoena;
enforce our terms and conditions; respond to your requests; or protect your, our, or others’ rights,
property, or safety. This may include laws outside your country of residence.
    </p>
    <p>
        <strong>Merger,Sale, or Other Corporate Transactions:</strong>
         If we are involved in a merger, acquisition, financing
due diligence, reorganization, bankruptcy, receivership, sale of our assets, or transition of service to
another provider, we have a legitimate interest in disclosing or transferring your Personal
Information as part of such a transaction.
    </p>
    <p> 
        <strong>With Your Consent:</strong>
        We may also disclose your information with your permission.
    </p>

    <h2>Information Secuity</h2>
    <p>
    We use certain physical, managerial, and technical safeguards that are designed to protect the
integrity and security of information that we collect and store. Please be aware that no security
measures are perfect, and we cannot ensure or warrant the security of any information you transmit
to us or store on our Services. If you have reason to believe that your interaction with us is no longer
secure, please immediately notify us in accordance with the “Contacting Us” section below.
    </p>

    <h2>International Users</h2>
    <p>
    By using the Services, you understand that your information may be transferred to countries outside
of your country of residence, which may have data protection rules that are different from those of
your country. In certain circumstances, courts, law enforcement agencies, regulatory agencies or
security authorities in those other countries may be entitled to access your Personal Information.
    </p>

    <h2>Accessing or Modifying your Information</h2>
    <p>
    You may update, correct, or delete your registration and profile information at any time by accessing
your account settings. More broadly, if you wish to access, correct, update, restrict, or delete
Personal Information, or to receive a copy of your Personal Information for the purpose of
transferring to another company (to the extent those rights are provided to you by applicable law),
you may contact us through the contact details below.
    </p>

    <p>
        <strong>Retention</strong>
        We retain Personal Information for as long as needed or permitted in light of the
purpose(s) for which it was obtained and consistent with applicable law. The criteria used to
determine our retention period include: the length of time we have an ongoing relationship with
you; legal obligations; or whether retention is advisable in light of our legal position. Any user may
request to have their Personal Information deleted at any time.
    </p>

    <h2>Third-Party Sales</h2>
    <p>
    This Privacy Policy does not address, and we are not responsible for, the privacy, information, or
other practices of any third parties, including any third party operating any website or service to
which the Services link. The inclusion of a link on the Services does not imply endorsement of the
linked site or service by us or by our affiliates.
    </p>

    <h2>Changes to our Privacy-policy</h2>
    <p>
    We may revise this policy from time to time. When we do, we will post the revised policy on this web
page, and the revised version will be effective when it is posted. By continuing to access or use our
Services after those changes become effective, you are agreeing to be bound by the revised policy.
    </p>

    {/* <h2>Contacting Us</h2>
    <p>Should you require additional information about your privacy rights or have any questions about this
Privacy Policy, send an email to us at <u id='email'>info@gictelemed.org</u> , detailing your request.</p> */}

    </div>

    <footer>
        &copy; 2023 Rava. All rights reserved.
    </footer>

    </>
    )
}

export default Index;